export var BaseUrl:string = 'https://admin.dev.userinsights.kimclark.com/api/v2.0/';
export var ApiGatewayUrl:string = "https://api.dev.userinsights.kimclark.com/oauth2/authorization/okta"

